import React, { useRef, useState } from 'react';
import '../styles/App.css';
import Slider from '@mui/material/Slider';
import Cropper, { Area } from "react-easy-crop";


type CropProps = {
  onAction?: (imageUrl: string | undefined, croppedAreaPixels: Area | null, rotation: number | null) => void;
  actionLabel?: string;
};

function EasyCrop({ onAction = () => console.log("Default action"), actionLabel = "" }: CropProps) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [imageUrl, setImageUrl] = useState<string | undefined>(undefined);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [prediction, setPrediction] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(null);


    const handleReset = () => {
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setRotation(0);
  };

  const handleChooseImg = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      const url = URL.createObjectURL(file);
      setImageUrl(url);
      setIsVisible(true);
    }
  };

  return (
    <div>
      <br></br>

      <div className="flex justify-center">
        <button onClick={handleChooseImg} type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
          Choose Image
          <svg className="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
          </svg>
        </button>
      </div>

      {/* Hidden file input */}
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />

      {isVisible && (
        <>
          <div className="flex justify-center">
            <div className="controls w-1/2">
              <label>
                Zoom
                <Slider
                  value={zoom}
                  min={0.1}
                  max={3}
                  step={0.1}
                  aria-labelledby="zoom"
                  onChange={(e, zoom) => setZoom(zoom)}
                  className="range"
                />
              </label>
              <label>
                Rotate
                <Slider
                  value={rotation}
                  min={0}
                  max={360}
                  step={1}
                  aria-labelledby="rotate"
                  onChange={(e, rotation) => setRotation(rotation)}
                  className="range"
                />
              </label>
            </div>
          </div>

          {/* Reset Button */}
          <div className="p-4 flex justify-center">
            <button onClick={handleReset} type="button" className="text-white bg-gray-600 hover:bg-gray-800 focus:outline-none font-small rounded-lg text-lg px-5 py-1.5 text-center inline-flex items-center">
              Reset Crop
            </button>
          </div>

          <div className="relative h-[400px] w-full bg-gray-900">
            <Cropper
              image={imageUrl}
              crop={crop}
              rotation={rotation}
              zoom={zoom}
              zoomSpeed={.1}
              minZoom={0.1}
              maxZoom={3}
              zoomWithScroll={true}
              showGrid={true}
              restrictPosition={false}
              aspect={3/4}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onRotationChange={setRotation}
              onCropComplete={(croppedArea, croppedAreaPixels) => {
                setCroppedAreaPixels(croppedAreaPixels); // store for later
              }}
            />
        </div>

          <div className="p-5 flex justify-center">
            <button onClick={() => onAction ( imageUrl, croppedAreaPixels, rotation )} type="button" className="text-white bg-blue-700 hover:bg-blue-800 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
              {actionLabel}
              <svg className="-rotate-90 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
              </svg>
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default EasyCrop;